import React, { useState } from 'react';

/* ── Sample reference data (representative of Excel lookups) ────── */

const HOUR_CLASSIFICATION = [
  { projectType: '.MS1|51-DL', payCode: 'RT', subGroup: 'Billable', description: 'Direct labor — billable project' },
  { projectType: '.MS1|51NB', payCode: 'RT', subGroup: 'Non-Billable', description: 'Project work — not billable to client' },
  { projectType: '.MS2|51-DL', payCode: 'RT', subGroup: 'Billable', description: 'Direct labor — billable project' },
  { projectType: '.MS2|51NB', payCode: 'RT', subGroup: 'Non-Billable', description: 'Project work — not billable to client' },
  { projectType: '.IS|51-DL', payCode: 'RT', subGroup: 'Billable', description: 'Direct labor — billable project' },
  { projectType: '.IS|51NB', payCode: 'RT', subGroup: 'Non-Billable', description: 'Project work — not billable to client' },
  { projectType: '.BL|51-DL', payCode: 'RT', subGroup: 'Billable', description: 'Direct labor — billable project' },
  { projectType: '.BL|51NB', payCode: 'RT', subGroup: 'Non-Billable', description: 'Project work — not billable to client' },
  { projectType: '81-OH', payCode: 'RT', subGroup: 'Overhead', description: 'Overhead labor' },
  { projectType: '95-B&P', payCode: 'RT', subGroup: 'B&P', description: 'Bid & Proposal' },
  { projectType: '90-G&A', payCode: 'RT', subGroup: 'G&A', description: 'General & Administrative' },
  { projectType: '96-IR&D', payCode: 'RT', subGroup: 'IR&D', description: 'Internal R&D' },
  { projectType: '60-HOL', payCode: 'HOL', subGroup: 'Holiday', description: 'Federal holidays' },
  { projectType: '60-FRINGE', payCode: 'PTO', subGroup: 'PTO', description: 'Paid time off' },
  { projectType: '60-FRINGE', payCode: 'LWOP', subGroup: 'LWOP', description: 'Leave without pay' },
  { projectType: '60-FRINGE', payCode: 'JURY', subGroup: 'Other Time Off', description: 'Jury duty' },
  { projectType: '60-FRINGE', payCode: 'BRV', subGroup: 'Other Time Off', description: 'Bereavement' },
  { projectType: '60-FRINGE', payCode: 'MLPD', subGroup: 'Other Time Off', description: 'Military leave — paid' },
  { projectType: '.CORP|51-DL', payCode: 'RT', subGroup: 'Billable', description: 'Corp direct labor — billable' },
  { projectType: '.CORP|51NB', payCode: 'RT', subGroup: 'Non-Billable', description: 'Corp project work — not billable' },
  { projectType: '81-OH', payCode: 'OT', subGroup: 'Overhead', description: 'Overhead — overtime' },
  { projectType: '95-B&P', payCode: 'OT', subGroup: 'B&P', description: 'B&P — overtime' },
  { projectType: '90-G&A', payCode: 'OT', subGroup: 'G&A', description: 'G&A — overtime' },
  { projectType: '60-FRINGE', payCode: 'ADM', subGroup: 'Other Time Off', description: 'Admin leave' },
  { projectType: '60-FRINGE', payCode: 'FLSA', subGroup: 'Other Time Off', description: 'FLSA comp time' },
  { projectType: '96-IR&D', payCode: 'OT', subGroup: 'IR&D', description: 'IR&D — overtime' },
];

const ORG_DIVISION_MAP = [
  { personOrganization: '01-BL', division: 'BL', lead: 'Roger' },
  { personOrganization: '02-IS', division: 'IS', lead: 'Greg' },
  { personOrganization: '03-MS1-A', division: 'MS1', lead: 'Mike' },
  { personOrganization: '03-MS1-B', division: 'MS1', lead: 'Mike' },
  { personOrganization: '04-MS2-A', division: 'MS2', lead: 'Nicole' },
  { personOrganization: '04-MS2-B', division: 'MS2', lead: 'Nicole' },
  { personOrganization: '05-CORP', division: 'Corp', lead: 'Ryan' },
  { personOrganization: '03-MS1-C', division: 'MS1', lead: 'Mike' },
  { personOrganization: '04-MS2-C', division: 'MS2', lead: 'Nicole' },
  { personOrganization: '01-BL-A', division: 'BL', lead: 'Roger' },
  { personOrganization: '02-IS-A', division: 'IS', lead: 'Greg' },
  { personOrganization: '05-CORP-A', division: 'Corp', lead: 'Ryan' },
];

const PERIOD_WORKDAYS = [
  { period: 'Jan 1-15', startDate: '2026-01-01', endDate: '2026-01-15', workdays: 11, quarter: 'Q1' },
  { period: 'Jan 16-31', startDate: '2026-01-16', endDate: '2026-01-31', workdays: 12, quarter: 'Q1' },
  { period: 'Feb 1-15', startDate: '2026-02-01', endDate: '2026-02-15', workdays: 10, quarter: 'Q1' },
  { period: 'Feb 16-28', startDate: '2026-02-16', endDate: '2026-02-28', workdays: 10, quarter: 'Q1' },
  { period: 'Mar 1-15', startDate: '2026-03-01', endDate: '2026-03-15', workdays: 11, quarter: 'Q1' },
  { period: 'Mar 16-31', startDate: '2026-03-16', endDate: '2026-03-31', workdays: 12, quarter: 'Q1' },
  { period: 'Apr 1-15', startDate: '2026-04-01', endDate: '2026-04-15', workdays: 11, quarter: 'Q2' },
  { period: 'Apr 16-30', startDate: '2026-04-16', endDate: '2026-04-30', workdays: 11, quarter: 'Q2' },
  { period: 'May 1-15', startDate: '2026-05-01', endDate: '2026-05-15', workdays: 11, quarter: 'Q2' },
  { period: 'May 16-31', startDate: '2026-05-16', endDate: '2026-05-31', workdays: 10, quarter: 'Q2' },
  { period: 'Jun 1-15', startDate: '2026-06-01', endDate: '2026-06-15', workdays: 11, quarter: 'Q2' },
  { period: 'Jun 16-30', startDate: '2026-06-16', endDate: '2026-06-30', workdays: 11, quarter: 'Q2' },
  { period: 'Jul 1-15', startDate: '2026-07-01', endDate: '2026-07-15', workdays: 11, quarter: 'Q3' },
  { period: 'Jul 16-31', startDate: '2026-07-16', endDate: '2026-07-31', workdays: 12, quarter: 'Q3' },
  { period: 'Aug 1-15', startDate: '2026-08-01', endDate: '2026-08-15', workdays: 11, quarter: 'Q3' },
  { period: 'Aug 16-31', startDate: '2026-08-16', endDate: '2026-08-31', workdays: 11, quarter: 'Q3' },
  { period: 'Sep 1-15', startDate: '2026-09-01', endDate: '2026-09-15', workdays: 11, quarter: 'Q3' },
  { period: 'Sep 16-30', startDate: '2026-09-16', endDate: '2026-09-30', workdays: 11, quarter: 'Q3' },
  { period: 'Oct 1-15', startDate: '2026-10-01', endDate: '2026-10-15', workdays: 11, quarter: 'Q4' },
  { period: 'Oct 16-31', startDate: '2026-10-16', endDate: '2026-10-31', workdays: 12, quarter: 'Q4' },
  { period: 'Nov 1-15', startDate: '2026-11-01', endDate: '2026-11-15', workdays: 10, quarter: 'Q4' },
  { period: 'Nov 16-30', startDate: '2026-11-16', endDate: '2026-11-30', workdays: 10, quarter: 'Q4' },
  { period: 'Dec 1-15', startDate: '2026-12-01', endDate: '2026-12-15', workdays: 11, quarter: 'Q4' },
  { period: 'Dec 16-31', startDate: '2026-12-16', endDate: '2026-12-31', workdays: 11, quarter: 'Q4' },
];

/* ── Tab config ──────────────────────────────────────────── */

const TABS = [
  { key: 'hour-classification', label: 'Hour Classification', count: HOUR_CLASSIFICATION.length },
  { key: 'org-division', label: 'Org / Division', count: ORG_DIVISION_MAP.length },
  { key: 'period-workdays', label: 'Period Workdays', count: PERIOD_WORKDAYS.length },
];

/* ── Sub-group badge color ───────────────────────────────── */

function subGroupClass(subGroup) {
  switch (subGroup) {
    case 'Billable': return 'cfg-badge-green';
    case 'Non-Billable': return 'cfg-badge-yellow';
    case 'Overhead': return 'cfg-badge-dim';
    case 'B&P': return 'cfg-badge-blue';
    case 'G&A': return 'cfg-badge-dim';
    case 'IR&D': return 'cfg-badge-blue';
    case 'Holiday': return 'cfg-badge-accent';
    case 'PTO': return 'cfg-badge-accent';
    case 'LWOP': return 'cfg-badge-red';
    case 'Other Time Off': return 'cfg-badge-dim';
    default: return 'cfg-badge-dim';
  }
}

/* ── Component ───────────────────────────────────────────── */

function DeliveryConfig() {
  const [activeTab, setActiveTab] = useState('hour-classification');
  const renderTable = () => {
    switch (activeTab) {
      case 'hour-classification':
        return (
          <div className="cfg-table-section">
            <div className="cfg-table-header">
              <div>
                <div className="cfg-table-title">Hour Classification Map</div>
                <div className="cfg-table-desc">
                  Maps each ProjectType + PayCode combination from the Unanet export to a utilization sub-group.
                  Updated when new project codes appear in Unanet (~quarterly).
                </div>
              </div>
            </div>
            <div className="data-table-wrapper">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Project Type</th>
                    <th>Pay Code</th>
                    <th>Sub-Group</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {HOUR_CLASSIFICATION.map((row, i) => (
                    <tr key={i}>
                      <td style={{ fontFamily: '"JetBrains Mono", monospace', fontSize: '12px' }}>{row.projectType}</td>
                      <td style={{ fontFamily: '"JetBrains Mono", monospace', fontSize: '12px' }}>{row.payCode}</td>
                      <td>
                        <span className={`cfg-badge ${subGroupClass(row.subGroup)}`}>{row.subGroup}</span>
                      </td>
                      <td style={{ color: 'var(--bcore-text-dim)', fontSize: '12px' }}>{row.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );

      case 'org-division':
        return (
          <div className="cfg-table-section">
            <div className="cfg-table-header">
              <div>
                <div className="cfg-table-title">Organization to Division Mapping</div>
                <div className="cfg-table-desc">
                  Maps Unanet PersonOrganization cost centers to B/CORE divisions and their default Portfolio Lead.
                  Rarely changes (only when new cost centers are created).
                </div>
              </div>
            </div>
            <div className="data-table-wrapper">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Person Organization</th>
                    <th>Division</th>
                    <th>Default Lead</th>
                  </tr>
                </thead>
                <tbody>
                  {ORG_DIVISION_MAP.map((row, i) => (
                    <tr key={i}>
                      <td style={{ fontFamily: '"JetBrains Mono", monospace', fontSize: '12px' }}>{row.personOrganization}</td>
                      <td>
                        <span className="cfg-badge cfg-badge-accent">{row.division}</span>
                      </td>
                      <td>{row.lead}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );

      case 'period-workdays':
        return (
          <div className="cfg-table-section">
            <div className="cfg-table-header">
              <div>
                <div className="cfg-table-title">Period Workday Counts</div>
                <div className="cfg-table-desc">
                  Business days per semi-monthly period. Set at the start of each fiscal year.
                  Used to calculate Available Hours (workdays x 8). FY2026 — 24 periods.
                </div>
              </div>
            </div>
            <div className="data-table-wrapper">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Period</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Workdays</th>
                    <th>Available Hours</th>
                  </tr>
                </thead>
                <tbody>
                  {PERIOD_WORKDAYS.map((row, i) => {
                    const prevQuarter = i > 0 ? PERIOD_WORKDAYS[i - 1].quarter : null;
                    const isNewQuarter = row.quarter !== prevQuarter;
                    const qPeriods = PERIOD_WORKDAYS.filter((p) => p.quarter === row.quarter);
                    const qWorkdays = qPeriods.reduce((s, p) => s + p.workdays, 0);
                    return (
                      <React.Fragment key={i}>
                        {isNewQuarter && (
                          <tr className="cfg-quarter-row">
                            <td colSpan={5}>
                              <span className="cfg-quarter-label">{row.quarter}</span>
                              <span className="cfg-quarter-summary">{qWorkdays} workdays &middot; {qWorkdays * 8} hrs</span>
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td className="cell-primary">{row.period}</td>
                          <td style={{ fontFamily: '"JetBrains Mono", monospace', fontSize: '12px' }}>{row.startDate}</td>
                          <td style={{ fontFamily: '"JetBrains Mono", monospace', fontSize: '12px' }}>{row.endDate}</td>
                          <td>{row.workdays}</td>
                          <td style={{ fontFamily: '"JetBrains Mono", monospace', fontSize: '12px' }}>{row.workdays * 8}</td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      {/* Page intro */}
      <div className="cfg-page-intro">
        <div className="cfg-page-intro-text">
          Reference data that drives utilization calculations. These lookup tables are currently maintained
          in the Excel tracker and will move to the portal in V2.
        </div>
        <div className="cfg-page-intro-badge">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
          Read-Only Preview
        </div>
      </div>

      {/* Tabs */}
      <div className="cfg-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`cfg-tab ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
            <span className="cfg-tab-count">{tab.count}</span>
          </button>
        ))}
      </div>

      {/* Active table */}
      {renderTable()}
    </div>
  );
}

export default DeliveryConfig;
